<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 p-4">
    <div class="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 space-y-6">
      
      <!-- Heading -->
      <h2 class="text-3xl font-bold text-center text-gray-800">
        Verify OTP sent to {{ maskedContact }}
      </h2>

      <!-- OTP Form -->
      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="text"
          placeholder="Enter OTP"
          v-model="otp"
          maxlength="6"
          required
          class="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-300"
        />
        <button
          type="submit"
          class="w-full bg-yellow-300 text-gray-900 font-bold py-2 rounded-md hover:bg-yellow-400 transition"
        >
          Verify OTP
        </button>
      </form>

      <!-- Resend OTP -->
      <button
        @click="resendOtp"
        class="text-pink-500 hover:underline text-sm w-full text-center"
      >
        Resend OTP
      </button>

    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const emit = defineEmits(["success","error","switch"]);

const otp = ref("");

// Get contact dynamically from sessionStorage
const contact = sessionStorage.getItem("signupData")
  ? JSON.parse(sessionStorage.getItem("signupData")).contact
  : sessionStorage.getItem("resetContact") || "";

// Masked contact for display: 1234****78
const maskedContact = ref(
  contact ? contact.replace(/(\d{4})\d{4}(\d{2})/, "$1****$2") : ""
);

const baseUrl = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";

// Submit OTP
const submit = async () => {
  if (!contact) return emit("error", "No contact found for verification.");

  // Decide which endpoint to hit based on context
  const isSignupFlow = !!sessionStorage.getItem("signupData");
  const endpoint = isSignupFlow ? "/verify-otp" : "/verify-reset-otp";

  try {
    const res = await fetch(`${baseUrl}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ contact, otp: otp.value }),
    });

    const data = await res.json();

    if (!res.ok) return emit("error", data.error || "OTP verification failed!");

    // Different success messages based on flow
    if (isSignupFlow) {
      emit("success", "Account created successfully. Please Login");
    } else {
      emit("success", "OTP verified!");
    }

    // Decide next step
    if (isSignupFlow) {
      emit("switch","login"); // After signup OTP
      sessionStorage.removeItem("signupData"); // Clear temp data
    } else {
      emit("switch","reset"); // After forgot password OTP
    }

  } catch {
    emit("error","Connection error");
  }
};

// Resend OTP
const resendOtp = async () => {
  if (!contact) return emit("error","No contact found.");

  const isSignupFlow = !!sessionStorage.getItem("signupData");

  try {
    // For signup, trigger /signup again with stored data; for reset, call /forgot-password again
    let res;
    if (isSignupFlow) {
      const signupData = JSON.parse(sessionStorage.getItem("signupData"));
      res = await fetch(`${baseUrl}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signupData),
      });
    } else {
      res = await fetch(`${baseUrl}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ contact }),
      });
    }

    const data = await res.json();
    if (!res.ok) return emit("error", data.error || "Failed to resend OTP!");

    emit("success", "OTP resent!");
  } catch {
    emit("error","Connection error");
  }
};
</script>
